module.exports = __webpack_public_path__ + "static/media/29BDOS16.5e1d6924.jpg";